import { render, staticRenderFns } from "./HeaderOutputFormat.vue?vue&type=template&id=1a72a56c&scoped=true"
import script from "./HeaderOutputFormat.vue?vue&type=script&lang=js"
export * from "./HeaderOutputFormat.vue?vue&type=script&lang=js"
import style0 from "./HeaderOutputFormat.vue?vue&type=style&index=0&id=1a72a56c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a72a56c",
  null
  
)

export default component.exports